import { Amplify } from 'aws-amplify';

export const GetCurrentLoggedInUsername = () => {
	return Amplify.Auth.currentUserInfo()
	.then(userInfo => userInfo.attributes.email.split('@')[0])
}